import axios from "axios";
import { config } from "../../config/appConfig";

export const CONTACT = {
    postContactDetails: {
        success : "POST_CONTACT"
    }
}

export const postContactDetails = (queryInfo) => {
    let url = `${config.BASE_URL}/contactUs`
    return dispatch => {
       return axios.post (url,queryInfo).then(response => {
            const data = response.data.data
            dispatch({type:CONTACT.postContactDetails.success, data})
            dispatch({type: "SERVER_SUCCESS", data: response.data})
            return true
        }).catch((err)=>{
            dispatch({type: "SERVER_ERROR", data: err.data})
            return false
        })
    }
}


// WEBPACK FOOTER //
// ./src/modules/contactUS/action.js